
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../services';

@Component({
  selector: 'app-image-gallery-modal',
  templateUrl: './image-gallery-modal.component.html',
  styleUrls: ['./image-gallery-modal.component.less']
})
export class ImageGalleryModalComponent implements OnInit,OnDestroy {

 currentIndex = 0;
  zoomed = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ImageGalleryModalComponent>,
    private api:ApiService
  ) {}



  @HostListener('window:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
  if (event.key === 'ArrowRight') {
    this.nextImage();
  } else if (event.key === 'ArrowLeft') {
    this.prevImage();
  } else if (event.key === 'Escape') {
    this.close();
  }
}

  nextImage(): void {
    this.currentIndex = (this.currentIndex + 1) % this.data.gallery.length;
    setTimeout(() => {
      this.adjustMargin();
    }, 100); 

  }
  prevImage(): void {
    this.currentIndex = (this.currentIndex - 1 + this.data.gallery.length) % this.data.gallery.length;
     setTimeout(() => {
      this.adjustMargin();
    }, 100); 

  }
 
  close(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.api.isGalleryModelOpened = true;
    this.currentIndex = this.data.index || 0;
     setTimeout(() => {
      this.adjustMargin();
    }, 100); 
  }
  ngOnDestroy(): void {
    this.api.isGalleryModelOpened = false;
  }

toggleZoom(): void {
  this.zoomed = !this.zoomed;
}

goToImage(index: number): void {
  this.currentIndex = index;
}


@ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('imageWrapper') imageWrapper!: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
  setTimeout(() => {
      this.adjustMargin();
    }, 100); 
  }

  @HostListener('window:resize')
  onResize() {
    this.adjustMargin();
  }

  adjustMargin() {
    const imageHeight = this.imageElement.nativeElement.offsetHeight;
    const viewportHeight = window.innerHeight;

    if (imageHeight > viewportHeight-120) {
      this.imageWrapper.nativeElement.style.marginBottom = '80px';
    } else {
      this.imageWrapper.nativeElement.style.marginBottom = 'auto';
    }
  }
} 